import {
  FILTER_VISIBLE,
  FILTER_PARAMS,
} from '../mutation-types';


const mutations = {
  [FILTER_VISIBLE](state, data) {
    state.filter.visible = data;
  },
  [FILTER_PARAMS](state, data) {
    state.filter.params = data;
  },
};

const state = {
  filter: {
    visible: false,
    params: {}
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/filter.js